function load(component) {
    return () =>import (`@/components/${component}.vue`);
};
export default {
    path:"production",
    component:load("production/layout"),
    children:[
        {
            path:"workOrder",
            name:"productionWorkOrder",
            component:load("production/workOrder/index"),
            meta: {
                parent: 'production',
                child: 'production',
                deal: true
            }
        },
        {
            path:"workOrder/details/:id",
            name:"productionWorkOrder-details",
            component:load("production/workOrder/details"),
            meta: {
                parent: 'production',
                child: 'production',
                deal: true
            }
        },
        {
            path:"workOrder/chart/:id",
            name:"productionWorkOrder-chart",
            component:load("production/workOrder/progressChart"),
            meta: {
                parent: 'production',
                child: 'production',
                deal: true
            }
        },
        {
            path:"scheduling",
            name:"productionScheduling",
            component:load("production/scheduling/index"),
            meta: {
                parent: 'production',
                child: ['scheduling','printing'],
                deal: true
            }
        },
        {
            path:"scheduling/history/:date",
            name:"productionScheduling-history",
            component:load("production/scheduling/history"),
            meta: {
                parent: 'production',
                child: ['scheduling','printing'],
                deal: true
            }
        },
        {
            path:"scheduling/createFirst",
            name:"productionScheduling-createFirst",
            component:load("production/scheduling/createFirst"),
            meta: {
                parent: 'production',
                child: 'scheduling',
                deal: false
            }
        },
        {
            path:"scheduling/createSecond",
            name:"productionScheduling-createSecond",
            component:load("production/scheduling/createSecond"),
            meta: {
                parent: 'production',
                child: 'scheduling',
                deal: false
            }
        },
        {
            path:"scheduling/details/:id",
            name:"productionScheduling-details",
            component:load("production/scheduling/details"),
            meta: {
                parent: 'production',
                child: 'scheduling',
                deal: true
            }
        },
        {
            path:"paperCutting",
            name:"productionPaperCutting",
            component:load("production/paperCutting/index"),
            meta: {
                parent: 'production',
                child: ['picking','cutting'],
                deal: true
            }
        },
        {
            path:"outsource",
            name:"productionOutsource",
            component:load("production/outsource/index"),
            meta: {
                parent: 'production',
                child: 'outsource',
                deal: true
            }
        },
        {
            path:"outsource/create",
            name:"productionOutsource-create",
            component:load("production/outsource/create"),
            meta: {
                parent: 'production',
                child: 'outsource',
                deal: false
            }
        }
    ],
};



// WEBPACK FOOTER //
// ./src/components/production/route/index.js